import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import { BusinessAdmins, Admins } from "constants/userRoles";
import { CREDIT_NOTE } from "constants/routes";

import CreditNotes from "views/CreditNotes/CreditNotesIndex";
import InvoiceDetail from "views/Invoice/InvoiceDetail/InvoiceDetail";

const CreditNotesRoute = () => (
  <Switch>
    <Route
      exact
      path={CREDIT_NOTE.INDEX}
      component={BusinessAdmins(CreditNotes)}
    />
    <Route
      exact
      path={CREDIT_NOTE.SHOW}
      render={({ match }) => (
        <Redirect
          to={CREDIT_NOTE.addId(CREDIT_NOTE.DETAIL, match.params.creditNoteID)}
        />
      )}
    />
    <Route path={CREDIT_NOTE.SHOW} component={Admins(InvoiceDetail)} />
  </Switch>
);

export default CreditNotesRoute;
